import React, { useState, useEffect } from 'react';
import InputPassword from '../UI/Control/InputPassword';
import Button from '../UI/Button/Button';
import MandatoryLabel from '../UI/Control/MandatoryLabel';
import { useSelector } from 'react-redux'

const SecretQuestion = (props) => {
    const [arrNoOfQues, setNoOfQues] = useState([]);
    const [arrSecretQuestion, setSecretQuestion] = useState([]);
    const EDCUserID = useSelector(state => state.auth.gValue01);
    const [userName, setUername] = useState('');

    const fetchEDCSecretQues = async () => {
        const response = await fetch('api/Users/GetEDCSecretQues')
        if (!response.ok) {
            throw new Error("Something went wrong, message :" + response.message + " \nHttp Error:" + response.httpError)
        }
        const secQues = await response.text();
        let listQues = JSON.parse(secQues);
        const arrSecQue = new Array();
        arrSecQue.push({ Name: '', Value: 0 })
        for (var iCount = 0; iCount < listQues.length; iCount++) {
            arrSecQue.push({ Name: listQues[iCount].SecretQuestion, Value: listQues[iCount].SecretQuestionId })
        }

        let arr = new Array();
        for (var iCount = 0; iCount < 5; iCount++) {
            arr.push({
                sequence: (iCount+1)
            });
        }
        setNoOfQues(arr);
        setSecretQuestion(arrSecQue);
    }

    function getUserName() {
        fetch('api/Users/GetUserNameByID?userID=' + EDCUserID)
            .then(response => response.text())
            .then(username => {
                setUername(username);
            });
    }

    useEffect(() => {
        getUserName();
        //fetchEDCSecretQues().catch((error) => {
        //    console.log(error.message)
        //});
    },[])

    const SaveSecretQuestion = () => { 
        if (validatePass() == false) {
            return false;
        }
        let objSecretQues = {
            EDCUserId: EDCUserID,
            UserName: userName,
            NewPassword: document.getElementById('txtNewPassword').value,
            listSecretQues: new Array()
        };        
        for (var iCount = 0; iCount < 5; iCount++) {            
            objSecretQues.listSecretQues.push({ SecQuesID: iCount+1, AnsText: 'abc'})
        }
        fetch('api/Users/SecQues_ChangePass', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(objSecretQues)
        }).then(res => res.text()).then(data => {
            if (data == 0 || data == -1) {
                alert('Change password not saved, Something went wrong.');
            }
            if (data > 0) {
                props.setSecQuesTrue();
            }
        });
    };

    const CancelSecretQuestion = (event) => {
        fetch('api/Users/ClearSession', {
            method: 'POST'
        })
        .then(response => response.text())
        .then(data => {
            props.dispatchLogout();
        });
    };

    function validatePass() {

        const objNewPassword = document.getElementById('txtNewPassword');
        if (objNewPassword.value.trim() == '') {
            alert('New password should not be empty.');
            objNewPassword.focus();
            return false;
        }
        if (objNewPassword.value.length < 8) {
            alert('New password should be minimum 8 chracter.');
            objNewPassword.focus();
            return false;
        }
        const objConfirmPassword = document.getElementById('txtConfirmPassword');
        if (objConfirmPassword.value.trim() == '') {
            alert('The confirmation password should not be empty.');
            objConfirmPassword.focus();
            return false;
        }
        if (objNewPassword.value != objConfirmPassword.value) {
            alert('The new password and the confirmation password should match.');
            objConfirmPassword.focus();
            return false;
        }
        return true;
    }
    return (
        <div className="container secQuesBorder" style={{ marginTop: "3%", marginBottom: "3%", "border": "solid", borderWidth: "thin" }}>           
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 secQuesHeader" style={{ "border": "1px solid", borderTop: "none", "padding": "5px" }}>
                    It appears that this is your first login or your password has been reset.  We ask that you please change the temporary password assigned to you to something else for security reasons.
                </div>

            </div>
            <div className="row secQuesBorder" style={{ "border": "1px solid", borderTop: "none" }}>
                    
                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 lblcol secQues" style={{ "padding": "3px", borderRight: "1px solid" }}><b>New password</b> <MandatoryLabel /> <br/>
                    (Password must be 8 letters long,which must contain at least one uppercase letter,  one lowercase letter, one number and one special character.)
                 </div>
                <div className="col-xs-8 col-sm-8 col-md-8 col-lg-8 fldcol secQues" style={{ paddingTop: "4px", paddingBottom: "4px" }}>
                    <InputPassword id="txtNewPassword" maxlength="50" style={{ width: "50%" }} placeholder="New Password"></InputPassword>
                </div>
            </div>
            <div className="row secQuesBorder" style={{ "border": "1px solid ", borderTop: "none" }}>
                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 lblcol secQues" style={{ "padding": "3px", borderRight: "1px solid" }}><b>New password again</b> <MandatoryLabel /> <br />
                    (Password must be 8 letters long,which must contain at least one uppercase letter,  one lowercase letter, one number and one special character.)
                 </div>
                <div className="col-xs-8 col-sm-8 col-md-8 col-lg-8 fldcol" style={{ backgroundColor: "#FFFFFF", paddingTop: "4px", paddingBottom: "4px" }}>
                    <InputPassword id="txtConfirmPassword" maxlength="50" style={{ width: "50%" }} placeholder="New Password Again"></InputPassword>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ backgroundColor: "#FFFFFF", "padding": "3px", textAlign: "center"}}>
                    <Button className="btn btn-success" style={{marginRight:"10px"}} onClick={SaveSecretQuestion}>
                        Save
                    </Button>
                    <Button className="btn btn-danger" onClick={CancelSecretQuestion}>
                        Cancel
                    </Button>
                </div>
            </div>

        </div>
    );
};
export default SecretQuestion;
